module.exports = __webpack_public_path__ + "static/img/2023年历-11.2c5b789.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-11.jpg
// module id = EJES
// module chunks = 3